import useAxiosService from './useAxiosService'
import { IResponse } from 'interfaces/services'

export const useCreateEditService = <T>() => {
  const { post, patch } = useAxiosService()
  const postCreateItem = async (
    url: string,
    payload: T
  ): Promise<IResponse<any>> => {
    const response: any = await post(url, payload)
    return response
  }

  const postEditItem = async (
    url: string,
    payload: T
  ): Promise<IResponse<any>> => {
    const response: any = await post(url, payload)
    return response
  }

  const patchEditItem = async (
    url: string,
    payload: T
  ): Promise<IResponse<any>> => {
    const response: any = await patch(url, payload)
    return response
  }

  return { postCreateItem, postEditItem, patchEditItem }
}
